import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import {
  Paginated,
  TenantGroup,
  TenantGroupCreate,
  TenantGroupPatch,
  TenantPermission,
  unwrapList,
} from './models';

@Injectable({ providedIn: 'root' })
export class GroupsService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);

  private base(slug: string): string {
    return `v1/tenants/${slug}`;
  }

  async list(slug: string): Promise<TenantGroup[]> {
    const res = await firstValueFrom(
      this.http.get<Paginated<TenantGroup>>(this.api.url(`${this.base(slug)}/groups/`)),
    );
    return unwrapList(res);
  }

  detail(slug: string, id: string) {
    return firstValueFrom(
      this.http.get<TenantGroup>(this.api.url(`${this.base(slug)}/groups/${id}/`)),
    );
  }

  create(slug: string, payload: TenantGroupCreate) {
    return firstValueFrom(
      this.http.post<TenantGroup>(this.api.url(`${this.base(slug)}/groups/`), payload),
    );
  }

  update(slug: string, id: string, patch: TenantGroupPatch) {
    return firstValueFrom(
      this.http.patch<TenantGroup>(this.api.url(`${this.base(slug)}/groups/${id}/`), patch),
    );
  }

  delete(slug: string, id: string) {
    return firstValueFrom(this.http.delete(this.api.url(`${this.base(slug)}/groups/${id}/`)));
  }

  async permissionsCatalog(slug: string): Promise<TenantPermission[]> {
    const res = await firstValueFrom(this.http.get<
      TenantPermission[] | { results: TenantPermission[] }
    >(this.api.url(`${this.base(slug)}/permissions/`)));
    return unwrapList(res);
  }
}
